import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './plugins/axios'
import "./assets/css/rest.css";
import "./assets/css/base.css";
import "./assets/css/element.css";

import * as filters from './filters' // global filters
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import {
  Divider,
  Backtop,
  Form,
  FormItem,
  Select,
  Option,
  Input,
  Button,
  Row,
  Col,
  DatePicker,
  TimeSelect,
  Radio,
  RadioGroup,
  Image,
  Avatar,
  Switch,
  PageHeader,
  Upload,
  CheckboxGroup,

  //提示
  Loading,
  Message,
  MessageBox,
  Notification
} from 'element-ui';

Vue.use(Divider); //分割线
Vue.use(Backtop); //回到顶部
Vue.use(Form); //表单
Vue.use(FormItem); //表单行
Vue.use(Select); //下拉框
Vue.use(Option); //下拉框option
Vue.use(Input); //输入框
Vue.use(Button); //按钮
Vue.use(Row); //布局行
Vue.use(Col); //布局列
Vue.use(DatePicker); //日期
Vue.use(TimeSelect); //时间
Vue.use(Radio); //单选框
Vue.use(RadioGroup); //单选框组合
Vue.use(Image); //图片
Vue.use(Avatar); //头像
Vue.use(Switch); //开关
Vue.use(PageHeader); //页头返回
Vue.use(Upload); //图片上传
Vue.use(CheckboxGroup); //多选框

Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");